document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.quick-add__submit');
    buttons.forEach((button) => {
      button.addEventListener('click', function() {
        const id = button.parentNode.dataset.modal;
  
        const section = document.querySelector(id);
        if (!section) return;
  
        // Verifica a cada 500ms se o modal está aberto
        const checkModal = setInterval(() => {
          if (document.querySelector(id).hasAttribute('open')) {
            if(section.querySelector('.flavours')) {
              newVariantPicker(section);
            }
            clearInterval(checkModal); // Para a verificação após executar a função
          }
        }, 500);
      })
    });
    
    function newVariantPicker(section) {
      // Inputs de quantidade de pacotes
      const qty_inputs = section.querySelectorAll('.qty_input');
      // Inputs de quantidade de cada Sabor
      const flavour_qty_inputs = section.querySelectorAll('.flavours__wrapper .quantity__input');
      // Botão de comprar
      const buy_button = section.querySelectorAll('.product-form__submit')[0];
      // Botão de aumentar quantidade de cada Sabor
      const flavour_qty_plus = section.querySelectorAll('.quantity__plus');
      // Botão de diminuir quantidade de cada Sabor
      const flavour_qty_minus = section.querySelectorAll('.quantity__minus');
      // Inputs para enviar quantidades de variantes para carrinho
      const variants_quantity = section.querySelectorAll('.variant-quantity');
      // Container de cada input de sabor
      const flavour_wrapper = section.querySelectorAll('.flavour-input_wrapper');
  
      // Preços a serem substituídos
      const old_price = section.querySelector('#regular-price');
      const old_sale_price = section.querySelector('#sale-price');
      const old_pix_price = section.querySelector('#pix-price');
      const pix_discount = old_pix_price.dataset.pixDiscount;
      
      // Quantidades de pacotes
      let quantities = [];
      qty_inputs.forEach((item, i) => {
        quantities.push(parseInt(item.value));
      })
  
      // Descontos de quantidade de pacotes
      const descontos = section.querySelector('.flavours').dataset.descontos.split(',');
  
      function formatMoney(value) {
        return value.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }).replace(/\u00A0/g, '');
      }
  
      function pricesAndButton(quantity) {    
        // Quantidade de sabores escolhidos
        let quantity_put = 0;
        let totalPrice = quantity * parseInt(flavour_qty_inputs[0].dataset.price)/100;
        flavour_qty_inputs.forEach((item) => {
          quantity_put = quantity_put + parseInt(item.value);
        });
        
        const index = quantities.indexOf(parseInt(quantity));
        let desconto = 1 - parseInt(descontos[index])/100;
        if(!desconto) desconto = 1;

        // Substitui preço sem desconto de quantidade de pacotes, esconde caso não tenha desconto e mostra caso tenha desconto
        if(desconto == 1){
          old_sale_price.parentElement.classList.add('visually-hidden'  );
          old_sale_price.textContent = '';            
        } else {
          old_sale_price.textContent = formatMoney(totalPrice);
          old_sale_price.parentElement.classList.remove('visually-hidden');          
        }
  
        // Substitui preço com desconto
        old_price.textContent = formatMoney(totalPrice * desconto);
        old_pix_price.textContent = formatMoney(totalPrice * desconto * pix_discount);
        
        // Ativar ou desativar botão de acordo com a quantidades
        buy_button.disabled = quantity_put != quantity;
        changeDisabled(quantity_put >= quantity);

        changeMinusDisabled();
      } 
      
      // Iteração entre todos os inputs de quantidade de pacotes
      qty_inputs.forEach((item) => {
        item.addEventListener('click', function() {
          var quantity = this.value;
          pricesAndButton(quantity);
        })
      })
  
      // Função para reforçar mínimo e máximo de quantidade
      function enforceMinMax(el) {
        if (el.value != "") {
          if (parseInt(el.value) < parseInt(el.min)) {
            el.value = el.min;
          }
          if (parseInt(el.value) > parseInt(el.max)) {
            el.value = el.max;
          }
        }
      }
  
      flavour_qty_inputs.forEach((item, i) => {
        item.addEventListener('change', function() {
          enforceMinMax(this);
  
          flavour_wrapper[i].classList.toggle('not-chosen', this.value == 0);
          variants_quantity[i].value = this.value;
  
          const quantity = section.querySelector('.qty_input:checked').value;
          pricesAndButton(quantity);
        })
      })
  
      function changeDisabled(disabled) {
        flavour_qty_plus.forEach((item, i) => {
          if (flavour_wrapper[i].classList.contains('unavailable')) {  
            item.disabled = true;
            item.classList.add('disabled');
            return;
          }
          item.disabled = disabled;
          item.classList.toggle('disabled', disabled);
        });
      }

      function changeMinusDisabled() {
        flavour_qty_minus.forEach((item, i) => {
          if(flavour_qty_inputs[i].value <= 0) {
            item.disabled = true;
            item.classList.add('disabled');
          } else {
            item.disabled = false;
            item.classList.remove('disabled');
          }
        });
      }
      
      changeDisabled(false);
      /*
      // Setando variantes pré-selecionadas
      let j = 0;
      let count = 0;
      
      while (count < quantities[0]) {
        // Se o wrapper não tiver a classe 'unavailable', clica e incrementa a contagem
        if (!flavour_wrapper[j].classList.contains('unavailable')) {
          flavour_qty_plus[j].click();
          count++; // Aumenta a contagem de cliques bem-sucedidos
        }
      
        // Avança para o próximo wrapper
        j++;
      
        // Se chegou ao final da lista, volta para o início
        if (j >= flavour_wrapper.length) {
          j = 0;
        }
      }
      */
      const quantity = section.querySelector('.qty_input:checked').value;
      pricesAndButton(quantity); 
    }

    const product_infos = document.querySelectorAll('product-info:has(.variants-wrapper)');
    product_infos.forEach((section) => {
      newVariantPicker(section);
    })
  })